/* [BD] Omega Fokus — bd-omega-fokus.liquid */
;(function () {
  var bdOmegaSwiperWaitMs = 50;
  var bdOmegaSwiperWaitMax = 120;

  function waitForSwiper(cb, left) {
    if (typeof window.Swiper === 'function') {
      cb();
      return;
    }
    left = typeof left === 'number' ? left : bdOmegaSwiperWaitMax;
    if (left <= 0) return;
    setTimeout(function () {
      waitForSwiper(cb, left - 1);
    }, bdOmegaSwiperWaitMs);
  }

  function destroyBdOmega(section) {
    if (!section) return;
    var sw = section._bdOmegaSwiper;
    if (sw && typeof sw.destroy === 'function') {
      try {
        sw.destroy(true, true);
      } catch (e) {}
      section._bdOmegaSwiper = null;
    }
    section.removeAttribute('data-bd-omega-init');
  }

  function initBdOmega(scope) {
    var roots = (scope || document).querySelectorAll('[data-bd-omega]');
    if (!roots.length) return;
    waitForSwiper(function () {
      roots.forEach(function (section) {
        if (!section || section.getAttribute('data-bd-omega-init')) return;
        var el = section.querySelector('[data-bd-omega-swiper]');
        if (!el || typeof window.Swiper !== 'function') return;

        var slideCount = el.querySelectorAll('.swiper-slide').length;
        if (!slideCount) return;

        var loopOn = section.getAttribute('data-bd-omega-loop') === 'true' && slideCount > 1;
        var autoplayOn = section.getAttribute('data-bd-omega-autoplay') === 'true' && slideCount > 1;
        var delayMs = parseInt(section.getAttribute('data-bd-omega-autoplay-delay'), 10);
        if (!delayMs || delayMs < 1000) delayMs = 4000;
        var speedMs = parseInt(section.getAttribute('data-bd-omega-speed'), 10);
        if (!speedMs || speedMs < 0) speedMs = 400;

        var opts = {
          slidesPerView: 'auto',
          spaceBetween: 12,
          speed: speedMs,
          loop: loopOn,
          watchOverflow: true,
        };

        if (autoplayOn) {
          opts.autoplay = {
            delay: delayMs,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          };
        }

        section.setAttribute('data-bd-omega-init', '1');
        try {
          section._bdOmegaSwiper = new window.Swiper(el, opts);
        } catch (e) {
          section.removeAttribute('data-bd-omega-init');
        }
      });
    });
  }

  function boot(scope) {
    initBdOmega(scope || document);
  }

  function onReady() {
    boot(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  if (window.Shopify && window.Shopify.designMode && !window.__bdSectionOmegaDesignMode) {
    window.__bdSectionOmegaDesignMode = true;
    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target) return;
      boot(e.target);
    });
    document.addEventListener('shopify:section:select', function (e) {
      if (!e.target) return;
      var omega = e.target.querySelector && e.target.querySelector('[data-bd-omega]');
      if (omega) {
        destroyBdOmega(omega);
        initBdOmega(e.target);
      }
    });
    document.addEventListener('shopify:section:unload', function (e) {
      if (!e.target || !e.target.querySelector) return;
      var omega = e.target.querySelector('[data-bd-omega]');
      if (omega) destroyBdOmega(omega);
    });
  }
})();
